var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.hasNewLeftNavEnabled
        ? _c("new-main-header", [_vm._v("\n    Customer History\n  ")])
        : _c("main-header", [
            _c(
              "span",
              { attrs: { slot: "arrow-back" }, slot: "arrow-back" },
              [
                _c(
                  "el-tooltip",
                  {
                    staticClass: "item",
                    attrs: {
                      effect: "dark",
                      content: "Back to Start Page",
                      placement: "bottom-start",
                    },
                  },
                  [
                    _c("router-link", { attrs: { to: { name: "HomePage" } } }, [
                      _c("i", { staticClass: "el-icon-back" }),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("span", { attrs: { slot: "page-title" }, slot: "page-title" }, [
              _vm._v("Customer History"),
            ]),
          ]),
      _vm._v(" "),
      _c(
        "main-content",
        [
          false
            ? _c(
                "el-menu",
                {
                  staticClass: "ring-menu--horizontal",
                  attrs: {
                    slot: "horizontal-menu",
                    "default-active": "1",
                    mode: "horizontal",
                  },
                  slot: "horizontal-menu",
                },
                [
                  _c(
                    "el-menu-item",
                    {
                      directives: [
                        {
                          name: "scroll-to",
                          rawName: "v-scroll-to",
                          value: {
                            el: "#history-app",
                            container: "#main-content",
                            duration: 500,
                            easing: "linear",
                          },
                          expression:
                            "{\n            el: '#history-app',\n            container: '#main-content',\n            duration: 500,\n            easing: 'linear'}",
                        },
                      ],
                      attrs: { index: "1" },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("history.app_activity")) +
                          "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-menu-item",
                    {
                      directives: [
                        {
                          name: "scroll-to",
                          rawName: "v-scroll-to",
                          value: {
                            el: "#history-events",
                            container: "#main-content",
                            duration: 500,
                            easing: "linear",
                          },
                          expression:
                            "{\n            el: '#history-events',\n            container: '#main-content',\n            duration: 500,\n            easing: 'linear'}",
                        },
                      ],
                      attrs: { index: "2" },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("history.events")) +
                          "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-menu-item",
                    {
                      directives: [
                        {
                          name: "scroll-to",
                          rawName: "v-scroll-to",
                          value: {
                            el: "#history-config",
                            container: "#main-content",
                            duration: 500,
                            easing: "linear",
                          },
                          expression:
                            "{\n            el: '#history-config',\n            container: '#main-content',\n            duration: 500,\n            easing: 'linear'}",
                        },
                      ],
                      attrs: { index: "3" },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("history.config")) +
                          "\n      "
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "main-content" }, slot: "main-content" },
            [
              _c("device-events", { attrs: { id: "history-events" } }),
              _vm._v(" "),
              _c("customer-setups", { attrs: { id: "history-setups" } }),
              _vm._v(" "),
              _c("device-history", { attrs: { id: "device-ownership" } }),
              _vm._v(" "),
              _c("el-card", { attrs: { id: "customer-transfers" } }, [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [
                    _c("span", { staticClass: "header-item" }, [
                      _vm._v(_vm._s(_vm.$t("dos.title"))),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "card-content" },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          id: "customer-transfers-link",
                          to: {
                            name: "CustomerTransfers",
                            params: { customer_id: _vm.customerId },
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("dos.view_transfers")) +
                            "\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("user-activity", { attrs: { id: "user-activity" } }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }